import React, {useState, useEffect} from 'react'
import { Table, Checkbox } from 'antd';
import { useNavigate } from "react-router-dom";
import { useFormContext } from '../../Context/FormContext';
import authQueries from '../../queries/authQueries';
import { useForm, Controller } from "react-hook-form";
// import {Checkbox} from "@nextui-org/react";

const Survey = () => {

  const navigate = useNavigate()

  const { formData, updateFormData, } = useFormContext();

  const { register, reset, control, handleSubmit, formState: { errors }} = useForm({});

  const SurveyData  = authQueries.useSurveyMutation(

    (response) => {

      console.log(response)
  
      if(response?.message === "Success") {
        navigate(-1)
      }
      else{
        navigate(-1)
      }
  
    }
    
  );

  const onSubmit = () => {

    updateFormData({ survey: datas })

    const datavalues = {
      data : {survey : datas },
    }

    console.log(datavalues)

    SurveyData.mutateAsync(datavalues);

  }


  const [datas, setDatas] = useState([])


  const questData = {
    work:[
    {id: 1, name: "I can freely report all unsafe acts/conditions"},
    {id: 2, name: "There is teamwork among my co workers"},
    {id: 3, name: "Management cares about my safety and wellbeing"},
    {id: 4, name: "Existence of no blame culture"},
    {id: 5, name: "High priority on safety training"},
    {id: 6, name: "Adequate rest provided."},
    {id: 7, name: "Breaking rules to achieve target"},
    {id: 8, name: "Regular safety checks"},
    ],
    Job: [
    {id: 9, name: "I know what is expected of me at work."},
    {id: 10, name: "I feel the freedom to “think outside the box.”"},
    {id: 11, name: "I am fairly compensated"},
    {id: 12, name: "I have the equipment/materials/resources I need in order to perform my job to the best of my ability."},
    {id: 13, name:"My assignments are clearly explained."},
    {id: 14, name: "I feel rushed to ensure that I meet deadlines."},
    {id: 15, name: "I feel like I do not get enough to do."},
    {id: 16, name: "I have opportunities to learn things outside of my specific job."},
    {id: 17, name: "I have the energy at the end of the work day to participate in my personal hobbies and interests."},
    ],
    manage: [
      {id: 18, name: "I feel that I can talk to my supervisor/manager about matters which concern me."},
      {id: 19, name: "My supervisor/manager stays up-to-date on what I am working on and what I have completed."},
      {id: 20, name: "I am complimented and given constructive criticism."},
      {id: 21, name: "I feel that my supervisor/manager doesn’t understand exactly what I do on a daily basis."},
      ],
  };
  


  return (

    <div className='informant'>

      <div className="container pt-5">

        <div className="row">

          <div className="card p-3 shadow mx-auto" style={{maxWidth:"800px", background: '#fff'}}>

            <div className='logo-container mb-4'>

              <img src={require("../../assets/images/logo.png")} className="logo" />

            </div>

            <p className='text-center' style={{color: '#0088ff'}}><strong>Employee Satisfaction Survey</strong></p>

            <p style={{fontSize: '14px', textAlign: 'justify', marginLeft: '10px', marginRight: '10px', color: 'black'}}>
              SHIPCONREP continuously finds ways to help you make your life as a seafarer better. Please take the time to fill out this survey as 
              honestly as possible. All responses will be kept confidential. Mark how you feel about each statement with a &#10004;.
            </p>

            <div className="tab-content informant-tab-pane p-3 border bg-light m-[10px] rounded-md">

              <div className="tab-pane active show">

                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ fontSize: '14px' }}>Work Ethics</th>
                      <th style={{ fontSize: '12px' }}>All of the time</th>
                      <th style={{ fontSize: '12px' }}>Most of the time</th>
                      {/* <th style={{ fontSize: '12px' }}>Neutral</th> */}
                      <th style={{ fontSize: '12px' }}>Sometimes</th>
                      <th style={{ fontSize: '12px' }}>Never</th>
                    </tr>
                  </thead>
                  <tbody>

                    {questData.work.map((item) => (

                      <Questions setDatas={setDatas} datas={datas} item={item} />

                    ))}

                  </tbody>
                  <thead>
                    <tr>
                      <th style={{ fontSize: '14px' }}>Job Responsibilities</th>
                      <th style={{ fontSize: '12px' }}>All of the time</th>
                      <th style={{ fontSize: '12px' }}>Most of the time</th>
                      {/* <th style={{ fontSize: '12px' }}>Neutral</th> */}
                      <th style={{ fontSize: '12px' }}>Sometimes</th>
                      <th style={{ fontSize: '12px' }}>Never</th>
                    </tr>
                  </thead>
                  <tbody>

                    {questData.Job.map((item) => (

                      <Questions setDatas={setDatas} datas={datas} item={item} />

                    ))}

                  </tbody>
                  <thead>
                    <tr>
                      <th style={{ fontSize: '14px' }}>Management</th>
                      <th style={{ fontSize: '12px' }}>All of the time</th>
                      <th style={{ fontSize: '12px' }}>Most of the time</th>
                      {/* <th style={{ fontSize: '12px' }}>Neutral</th> */}
                      <th style={{ fontSize: '12px' }}>Sometimes</th>
                      <th style={{ fontSize: '12px' }}>Never</th>
                    </tr>
                  </thead>
                  <tbody>

                    {questData.manage.map((item) => (

                      <Questions setDatas={setDatas} datas={datas} item={item} />

                    ))}

                  </tbody>
                  {/* Repeat the above structure for Job Responsibilities and Management categories */}
                </table>

              </div>

            </div>

            {/* {JSON.stringify(datas)} */}

            <div className="row">

              <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">

                    <button onClick={() => navigate(-1)} className="btn btn-primary btn-informant !flex items-center justify-center">Go Back <i className="icon-check"></i></button>
                
                </div>

              </div>

              <div className='col-md-6'>

                <div className="d-grid gap-2 mt-4 mb-4">

                    <button onClick={handleSubmit(onSubmit)} className="btn btn-primary btn-informant !flex items-center justify-center">Submit <i className="icon-check"></i></button>
                
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

    

  )
}

export default Survey

const Questions = ({item, datas, setDatas}) => {
  
  const queArr = ['all', 'most', 'sometimes', 'never']

  const handleChange = (e, values) => {

  const data = {
    survey_id: item.id,
    all: values === 'all' ? 'TRUE' : 'FALSE',
    most: values === 'most' ? 'TRUE' : 'FALSE',
    // neutral: values === 'neutral' ? 'TRUE' : 'FALSE',
    sometimes: values === 'sometimes' ? 'TRUE' : 'FALSE',
    never: values === 'never' ? 'TRUE' : 'FALSE',
  } 

    

    const dataExist = datas.find(element => element.survey_id === item.id )

    if(dataExist){
      const dataChange = datas.filter(element => element.survey_id != item.id)
      let surveyArr = []
      surveyArr = [...dataChange, data]
      setDatas(surveyArr)
    }
    else {

      let surveyArr = []
    
      surveyArr = [...datas, data]

      setDatas(surveyArr)
      
    }

  }

  return(

    <tr>
      <td className='text-[14px]'>{item.name}</td>
      {
        queArr.map((items) => (
          <td>
            <QuestCheckbox item={item} datas={datas} handleChange={handleChange} items={items} />
          </td>
        ))
      }
    </tr>
  )
}

const QuestCheckbox = ({items, item, handleChange, datas}) => {

  const [checked , setChecked] = useState(false)

  useEffect(() => {
    const survey = datas.find(ele => ele.survey_id === item.id)


    if(survey?.[items] === "TRUE"){
        setChecked(true)
      }
      else{
        setChecked(false)
      }
   
  }, [datas]);

  

  return(
    // <input
    //   style={{width: 25, height: 25, borderRadius: 10}}
    //   type="checkbox"
    //   checked={checked}
    //   onChange={(e) => handleChange(e.target.checked, items)}
    // /> 
    <Checkbox
      checked={checked}
      onChange={(e) => handleChange(e.target.checked, items)}
    >
    </Checkbox>
  )
}
